export const MASCOT_NAME = "Maurilho da AMC";
export const MASCOT_IMG = "/mascote/rafa-avatar-v2.webp";
export const MASCOT_FULL = "/mascote/rafa-full-v2-cut.webp";
export const MASCOT_THUMBS = "/mascote/rafa-joinha-v2-cut.webp";
export const MASCOT_STANDING = "/mascote/rafa-full-v2-cut.webp";

export const GREETING = [
  "Oi! Eu sou o Maurilho, da AMC Escolas.",
  "Tô aqui pra tirar suas dúvidas sobre os nossos serviços e o Faz Depois Paga. É só tocar numa pergunta.",
];

export const FAQ = [
  {
    id: "servicos",
    q: "O que a AMC faz?",
    a: [
      "Cuidamos da manutenção de escolas municipais e estaduais: reparos civis, hidráulica, elétrica, pintura e marcenaria.",
      "Também fazemos instalações elétricas, grades, telas de proteção, limpeza de caixa d'água e vistorias, com equipe própria.",
    ],
  },
  {
    id: "fdp",
    q: "Como funciona o Faz Depois Paga?",
    a: [
      "No Faz Depois Paga a escola resolve a manutenção sem esperar aprovação: o serviço começa no mesmo dia.",
      "Os serviços vão se acumulando num ciclo com limite de prazo e de valor. Quando um dos dois é atingido, sai uma única nota fiscal e a escola paga depois do serviço feito.",
    ],
    link: { to: "/faz-depois-paga", label: "Ver tudo sobre o FDP" },
  },
  {
    id: "orcamento",
    q: "Como peço um orçamento?",
    a: [
      "Você deixa seu contato aqui comigo e a nossa equipe fala com você.",
      "O orçamento chega digital no Portal da Escola: a direção vê cada item, aprova pelo celular e acompanha o andamento até a nota fiscal.",
    ],
  },
  {
    id: "preco",
    q: "Quanto custa?",
    a: [
      "Cada escola tem uma necessidade diferente, por isso o valor sai sempre no orçamento, item por item.",
      "Se quiser, deixe seu contato que a gente prepara o seu.",
    ],
  },
  {
    id: "portal",
    q: "Como acesso o Portal da Escola?",
    a: [
      "1. Solicite o acesso e enviamos o convite de Diretor(a).",
      "2. Entre pelo celular ou computador e instale o app na tela inicial.",
      "3. Pronto: orçamentos, aprovações, fotos dos serviços e avisos da AMC na palma da mão.",
    ],
    link: { to: "/escola/login", label: "Já tenho acesso" },
  },
  {
    id: "regiao",
    q: "Vocês atendem a minha escola?",
    a: ["Atendemos escolas municipais e estaduais com equipe própria na região. Deixe seu contato com o nome da escola que confirmamos pra você."],
  },
];

export const LEAD_STEPS = [
  { key: "name", ask: "Show! Qual é o seu nome?", placeholder: "Seu nome" },
  { key: "school", ask: "Qual é a escola?", placeholder: "Nome da escola" },
  { key: "phone", ask: "E um telefone ou WhatsApp com DDD?", placeholder: "(11) 90000-0000", type: "tel" },
];
